<script setup>
import { ref } from 'vue';
import { useKaleadicalStore } from '@/stores/kaleadical';
import { storeToRefs } from 'pinia';
import { router } from '@inertiajs/vue3';

const { search } = useKaleadicalStore();
const { all } = storeToRefs(useKaleadicalStore());

const params = ref({
    term: '',
    page: 1,
    sort_by: null,
    per_page: 10,
});

const searchKaleadicals = () => {
    search({
        ...params.value,
    });
};

const tableUpdate = ({ page, sortBy, itemsPerPage }) => {
    Object.assign(params.value, { page, sort_by: sortBy, per_page: itemsPerPage });
    searchKaleadicals();
};

const goToCreate = () => {
    router.visit('/kaleadicals/create');
};
const goToEdit = (item) => {
    router.visit('/kaleadicals/create/' + item.hash);
};
const goToView = (item) => {
    router.visit('/kaleadicals/edit/' + item.hash);
};

const imgErrors = ref([]);

const hasError = (hash) => {
    return imgErrors.value.includes(hash);
};

const handleImageError = (hash) => {
    imgErrors.value.push(hash);
};
</script>

<template>
<MainContentLayout>
    <template #breadcrumb><BreadCrumb /></template>
    <template #title>Kaleadicals</template>
    <template #actions>
        <StyledButton color="primary" @click="goToCreate()">
            <FontAwesomeIcon icon="plus" class="mr-1" /> New Kaleadical
        </StyledButton>
    </template>
    <!-- <div class="grid lg:grid-cols-3 md:gap-4 md:mb-4">
        <StyledSearch
            v-model="params.term"
            v-debounce:500ms="searchKaleadicals"
            name="search"
            :label="$t('label.search')"
            :debounce-events="['input']"
            @click:clear="clearSearch" />
    </div> -->
    <DataTable
        v-if="all"
        :data="all"
        :headers="[
            { title: 'Name', key: 'name' },
            { title: 'Preview', key: 'preview' }
        ]"
        :actions="[
            {
                title: 'Edit',
                icon: 'mdi-view-dashboard-edit',
                action: (item) => goToEdit(item),
            },
            {
                title: 'View',
                icon: 'mdi-view-dashboard-edit',
                action: (item) => goToView(item),
            },
        ]"
        @table-update="tableUpdate">

        <template #[`item.preview`]="{ item }">
            <div class="w-full flex justify-center md:justify-start">
                <img
                    v-if="!hasError(item.hash)"
                    :src="`/api/v1/kaleadicals/${item.hash}/image?${Date.now()}`"
                    class="w-32 h-32 object-cover cursor-pointer"
                    @click="goToView(item)"
                    @error="handleImageError(item.hash)">
            </div>
        </template>
    </DataTable>
</MainContentLayout>
</template>
